import gql from "graphql-tag";

export const ADD_AREA = gql`
 mutation insert_area($id: uuid!,$area: String!,$groupId: uuid!,$cityId: uuid!) {
  insert_area(objects: {id: $id, area: $area, groupId: $groupId, cityId: $cityId}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_AREA = gql`
 mutation ($areaId: uuid!,$area: String!,$groupId: uuid!,$cityId: uuid!) {
   update_area (where: {id: {_eq: $areaId}}, _set: {area: $area, groupId: $groupId, cityId: $cityId}) {
    returning {
      id
     }
    } 
  }
`
export const DELETE_AREA = gql`
 mutation ($areaId: uuid!) {
   delete_area(where: {id: {_eq: $areaId}}) {
    returning {
      id
     }
    }   
  }
`